// src/lib/services-autotranslate.js — Libellés services multilingues (prérequis
// hub services payants).
//
// Auto-traduction AU SAVE des libellés du catalogue services : FR → EN + ES
// UNIQUEMENT pour les langues cibles VIDES (jamais d'écrasement d'une saisie ou
// d'une traduction antérieure), non bloquant (tout échec laisse la cible vide →
// repli es→en→fr au read via pickLangChain). MÊME pattern que le livret
// (ADR-200) et le formulaire (api/form-translate.js).
//
// Réemploie `autoTranslateEmptyLangs` (helper livret, endpoint Claude Haiku 4.5)
// et ajoute la GARDE ANTI-BAVARDAGE `looksLikeMetaResponse` (miroir de
// api/form-translate.js) : Haiku désobéit parfois au « Output ONLY » et renvoie
// une méta-réponse (« Here is the translation… »). L'endpoint livret_translate
// ne filtre PAS ce cas (il ne rejette que la sortie vide) → on filtre ICI, côté
// service, pour ne jamais persister une phrase parasite. Sortie suspecte =
// rejetée → cible laissée vide → fallback FR (jamais de fuite de méta-réponse).
//
// La garde ne s'applique QU'aux valeurs NOUVELLEMENT produites (cible qui était
// vide) : une saisie/correction manuelle EN/ES est la source de vérité et n'est
// jamais ni traduite ni filtrée (autoTranslateEmptyLangs ne la touche pas).

import { autoTranslateEmptyLangs } from "./livret-autotranslate";

// Marqueurs de méta-réponse — miroir de api/form-translate.js (garde-fou B5).
const META_MARKERS =
  /(i['’]?m ready|i can (help|translate|assist)|i['’]?ll translate|happy to (help|translate)|you['’]?d like me to|here (is|'s) the translation|as an ai|je peux (traduire|aider)|voici la traduction|estoy listo|puedo (traducir|ayudar)|aquí (está|tienes) la traducción)/i;

/**
 * Détecte une sortie IA « bavarde » (méta-réponse) plutôt qu'une traduction.
 * Miroir fidèle de api/form-translate.js::looksLikeMetaResponse.
 * @param {string} translated sortie IA candidate
 * @param {string} source texte FR source
 * @returns {boolean} true si la sortie ressemble à une méta-réponse (à rejeter)
 */
export function looksLikeMetaResponse(translated, source) {
  const out = String(translated || "");
  const src = String(source || "");
  if (META_MARKERS.test(out)) return true;
  // Parle de « traduire » sans que la source soit elle-même à ce sujet.
  const outTalksTranslation = /\b(translat|traduc|traduzc|traduci)/i.test(out);
  const srcAboutTranslation = /\b(traduc|translat)/i.test(src);
  if (outTalksTranslation && !srcAboutTranslation) return true;
  // Backstop longueur (defense-in-depth, pas le critère principal).
  if (src.length > 0 && out.length > src.length * 3 + 40) return true;
  return false;
}

/**
 * Auto-traduit UN champ i18n de service (titre OU description) au save.
 * Remplit EN/ES vides depuis le FR, jamais d'écrasement, non bloquant, avec
 * garde anti-bavardage sur les valeurs nouvellement produites.
 *
 * @param {object} p
 * @param {string} p.fr texte source FR
 * @param {string} p.en valeur EN actuelle (vide ⇒ candidate à traduction)
 * @param {string} p.es valeur ES actuelle (vide ⇒ candidate à traduction)
 * @param {"title"|"content"} p.context contexte de traduction
 * @returns {Promise<{en: string, es: string}>} valeurs finales (jamais null)
 */
export async function autoTranslateServiceField({ fr, en, es, context }) {
  const frTrim = (fr || "").trim();
  const enWasEmpty = !(en || "").trim();
  const esWasEmpty = !(es || "").trim();

  const { en: enOut, es: esOut } = await autoTranslateEmptyLangs({
    fr,
    en,
    es,
    context,
  });

  // Garde anti-bavardage : uniquement sur une valeur NOUVELLEMENT produite
  // (cible qui était vide). Une méta-réponse est rejetée → cible remise à ""
  // (fallback FR au read). Une saisie manuelle existante n'est jamais filtrée.
  const enGuarded =
    enWasEmpty && enOut && looksLikeMetaResponse(enOut, frTrim) ? "" : enOut;
  const esGuarded =
    esWasEmpty && esOut && looksLikeMetaResponse(esOut, frTrim) ? "" : esOut;

  return { en: enGuarded, es: esGuarded };
}
